(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacesheetSection', FacesheetSection);

    FacesheetSection.$inject = ['$resource'];

    function FacesheetSection ($resource) {
        var resourceUrl =  'api/facesheet-sections/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByFacility': {url: 'api/facesheet-sections/facility/:id', method: 'GET', isArray: true}
        });
    }
})();
